// CONTRACT:
// PURPOSE: [Клиент-компонент главной: reveal-анимации и счётчики data-count]
// SCOPE: [landing, animation, IntersectionObserver]
// AI_REFLECTION: [SCORE: Q=9, R=8, M=9] [DEPTH: standard]
//   [NOTE: Без библиотек: один IntersectionObserver на все [data-reveal].
//    Счётчики [data-count] анимируются при появлении блока, формат ru-RU.]

"use client";

import { useEffect } from "react";

export function HomeReveal() {
  useEffect(() => {
    const prefersReduce = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    const fmt = (n: number) =>
      Math.round(n)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, "\u00A0");

    const runCount = (el: HTMLElement) => {
      const target = parseInt(el.getAttribute("data-count") || "0", 10) || 0;
      if (prefersReduce) {
        el.textContent = fmt(target);
        return;
      }
      const dur = 1100;
      let start: number | null = null;
      const step = (ts: number) => {
        if (start === null) start = ts;
        const p = Math.min((ts - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(target);
      };
      requestAnimationFrame(step);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add("in");
          const counters = e.target.querySelectorAll<HTMLElement>("[data-count]");
          counters.forEach((c) => {
            if (!c.dataset.done) {
              c.dataset.done = "1";
              runCount(c);
            }
          });
          io.unobserve(e.target);
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
    );

    document.querySelectorAll(".portal-reveal[data-reveal]").forEach((el) => {
      io.observe(el);
    });

    // Счётчики вне reveal-блоков (тикер) — запускаем сразу
    document.querySelectorAll<HTMLElement>("[data-count]").forEach((c) => {
      if (!c.closest("[data-reveal]") && !c.dataset.done) {
        c.dataset.done = "1";
        runCount(c);
      }
    });

    return () => io.disconnect();
  }, []);

  return null;
}
